import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-100 to-background-200 border border-background-300/50 rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <span className="text-xs text-accent-400 bg-accent-500/10 px-2 py-1 rounded-full mb-3 inline-block whitespace-nowrap">
              {appData.subtitle}
            </span>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              {appData.desc}
            </p>
            <div className="flex flex-wrap gap-2 justify-center md:justify-start mb-5">
              {appData.features.map((feat, idx) => (
                <span
                  key={idx}
                  className="text-xs px-2.5 py-1 rounded-full bg-background-50 border border-background-200/70 text-foreground-600 whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-400 mr-1"></i>
                  {feat}
                </span>
              ))}
            </div>
            <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-smartphone-line"></i>
              添加到主屏幕
            </button>
          </div>
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-300 flex items-center justify-center border border-background-300/50">
            <i className="ri-smartphone-line text-6xl text-primary-400"></i>
          </div>
        </div>
      </div>
    </section>
  );
}